import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';

@Injectable()
export class NotificationService {

    users = [];
    private currentUsersSubject = new BehaviorSubject<any[]>([]);
    public currentUsers = this.currentUsersSubject.asObservable();
    private audio = new Audio('assets/alarm.mp3');
    private autoplayUnlockAttached = false;

    constructor(
        private apiService: ApiService
    ) {
        this.audio.load();
    }

    private tryPlay() {
        if (!this.audio.paused) {
            return;
        }
        this.audio.loop = true;
        const playPromise = this.audio.play();
        if (playPromise !== undefined) {
            playPromise.catch(() => {
                this.attachAutoplayUnlock();
            });
        }
    }

    private attachAutoplayUnlock() {
        if (this.autoplayUnlockAttached) {
            return;
        }
        this.autoplayUnlockAttached = true;

        const unlock = () => {
            document.removeEventListener('pointerdown', unlock, true);
            document.removeEventListener('keydown', unlock, true);
            document.removeEventListener('touchstart', unlock, true);
            this.autoplayUnlockAttached = false;

            if (this.users.length > 0) {
                this.tryPlay();
            }
        };

        document.addEventListener('pointerdown', unlock, true);
        document.addEventListener('keydown', unlock, true);
        document.addEventListener('touchstart', unlock, true);
    }

    addUserAlarm(user) {
        this.tryPlay();

        if (this.users.findIndex(j => j.alarmID === user.alarmID) === -1) {
            this.users.push(user);
            this.currentUsersSubject.next(this.users);
            this.savePendingAlarms();
        }
    }

    addUserEBSAlarm(user) {
        this.tryPlay();

        if (this.users.findIndex(j => j.alarmID === user.alarmID) === -1) {
            this.users.push(user);
            this.currentUsersSubject.next(this.users);
            this.savePendingAlarms();
        }
    }

    deleteUserAlarm(user) {
        this.stopAlarm();
        const userIndex = this.users.findIndex(j => j.alarmID == user.alarmID);
        if (userIndex >= 0) {
            this.users.splice(userIndex, 1);
            this.currentUsersSubject.next(this.users);
            this.savePendingAlarms();
        }
    }

    clean() {
        this.users = [];
        this.audio.pause();
        this.currentUsersSubject.next(this.users);
        sessionStorage.removeItem('pendingAlarms');
    }

    private savePendingAlarms() {
        if (this.users.length > 0) {
            sessionStorage.setItem('pendingAlarms', JSON.stringify(this.users));
        } else {
            sessionStorage.removeItem('pendingAlarms');
        }
    }

    getPendingAlarms(): any[] {
        try {
            const data = sessionStorage.getItem('pendingAlarms');
            return data ? JSON.parse(data) : [];
        } catch (e) {
            return [];
        }
    }

    stopAlarm() {
        this.audio.pause();
    }

    getAlarmUsers(): Observable<any> {
        return this.currentUsers;
    }

    getAlarmArray() {
        return this.users;
    }

    muteAlarm(result) {
        this.audio.muted = result;
    }

    getListOfResponders(imei): Observable<any> {
        return this.apiService.get(`/alarm/getListOfResponders/${imei}`);
    }

    getListOfRespondersBasic(imei): Observable<any> {
        return this.apiService.get(`/alarm/getListOfRespondersBasic/${imei}`);
    }

    sendNotificationsToResponders(data): Observable<any> {
        return this.apiService.post(`/alarm/sendNotif`, data);
    }

    checkAllowNotifyResponders(alarm_id, body): Observable<any> {
        return this.apiService.post(`/alarm/checkAllowNotifyResponders/${alarm_id}`, body);
    }

    getStatusesFromAlarm(alarm_id): Observable<any> {
        return this.apiService.get(`/alarm/getStatusesFromAlarm/${alarm_id}`);
    }

    sentActionsCheck(alarm_id): Observable<any> {
        return this.apiService.get(`/alarm/sentActionsCheck/${alarm_id}`);
    }

}
